import { useState, useEffect } from "react";
import Phone from "./features/mobile/Phone";
import Pool from "./pool";
import { useAppDispatch } from "./app/hooks";
import { appSlice } from "./app/appSlice";

function Interactive() {
  const width = 2000;
  const height = 1125;
  const dispatch = useAppDispatch();
  const [scale, setScale] = useState(
    window.innerWidth / window.innerHeight < width / height
      ? window.innerWidth / width
      : window.innerHeight / height
  );

  useEffect(() => {
    const handleWindowResize = () => {
      setScale(
        window.innerWidth / window.innerHeight < width / height
          ? window.innerWidth / width
          : window.innerHeight / height
      );
    };

    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, [setScale]);
  return (
    <div className="">
      <div className="absolute top-1/2 left-0 z-10 -translate-y-1/2">
        <div
          className="pl-10 box-content w-[400px] rounded-[54px] origin-left"
          style={{ transform: `scale(${scale})` }}
        >
          <img
            src="jandy-white.png"
            className="w-auto h-10 absolute -top-15 left-6"
            alt="Jandy"
          />
          <Phone>
            <iframe
              src="#/appcontent?safe-areas=true"
              title="App"
              className="w-full h-full relative rounded-[38px]"
            />
          </Phone>
          <div className="m-auto flex flex-row items-center justify-center pt-5">
            <button
              className="w-auto flex flex-row items-center justify-center"
              onClick={() => {
                dispatch(appSlice.actions.toggleAlexaInterface());
                dispatch(appSlice.actions.setPartyMode(false));
              }}
            >
              <svg
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 77.83 124.72"
                className="microphone"
                style={{ width: "75px" }}
              >
                <defs></defs>
                <rect
                  style={{ fill: "#fff" }}
                  x="15.31"
                  y="0"
                  width="47.21"
                  height="84.85"
                  rx="23.6"
                  ry="23.6"
                />
                <path
                  style={{ fill: "#fff" }}
                  d="m71.45,61.2h0c0,17.95-14.39,32.79-32.35,32.89-18.03.1-32.73-14.53-32.73-32.53h0c0-1.06-.86-1.91-1.91-1.91H1.91c-1.06,0-1.91.86-1.91,1.91h0c0,20.38,15.75,37.16,35.73,38.78v17.99h-18.34c-1.06,0-1.91.86-1.91,1.91v2.55c0,1.06.86,1.91,1.91,1.91h43.06c1.06,0,1.91-.86,1.91-1.91v-2.55c0-1.06-.86-1.91-1.91-1.91h-18.34v-17.99c19.97-1.63,35.73-18.4,35.73-38.78h0c0-1.06-.86-1.91-1.91-1.91h-2.91c-.86,0-1.56.7-1.56,1.56Z"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
      <Pool className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-0" />
    </div>
  );
}

export default Interactive;
